/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { type AnalyticsEvent, HallowAnalyticsEvent } from "@packages/analytics";
import {
  cssMediaQueryMinWidthTablet,
  spacing,
  Text,
  useIsDesktopViewport,
} from "@packages/ui";

import { CTA } from "../CTA";

const containerStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row-reverse",
  flexWrap: "wrap",
  justifyContent: "space-evenly",
  marginBlock: spacing.xxl,
  rowGap: spacing.l,
  transformStyle: "preserve-3d",
};

const textStyles: Interpolation = {
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  gap: spacing.l,
  justifyContent: "flex-start",
  alignItems: "center",
  textAlign: "center",
  [cssMediaQueryMinWidthTablet]: {
    alignItems: "flex-start",
    textAlign: "start",
  },
};

const imageStyles: Interpolation = {
  height: "165px",
  [cssMediaQueryMinWidthTablet]: {
    height: "242px",
  },
};

type CtaSectionProps = {
  title: string;
  button: string;
  image: string;
  event?: HallowAnalyticsEvent;
  eventProperties?: AnalyticsEvent["properties"];
};

export const CtaSection = ({
  image,
  title,
  button,
  event,
  eventProperties = {},
}: CtaSectionProps) => {
  const isDesktop = useIsDesktopViewport();

  return (
    <div css={containerStyles}>
      <div key={"image"}>
        <img src={image} alt={""} css={imageStyles} />
      </div>
      <div key={"text"} css={textStyles}>
        <Text as={"h2"} type={"headline"} size={isDesktop ? "l" : "s"}>
          {title}
        </Text>
        <CTA
          event={event ?? HallowAnalyticsEvent.TappedSecondaryCTA}
          eventProperties={{
            screen_name: "homepage",
            button,
            ...eventProperties,
          }}
          variant="primary"
          size="l"
        >
          {button}
        </CTA>
      </div>
    </div>
  );
};
